module.exports = __webpack_public_path__ + "static/media/emma-and-grace-2.c261dcaf.jpg";